import type { ReactNode } from 'react';
import { Brain } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '../lib/cn.js';

export interface NavBarProps {
  userMenu?: ReactNode;
  className?: string;
}

export function NavBar({ userMenu, className }: NavBarProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-40 flex h-16 items-center gap-4 px-6 bg-bg-base/95 backdrop-blur border-b border-border-subtle',
        className,
      )}
    >
      <Link
        to="/"
        className="flex items-center gap-2 text-lg font-semibold text-text-primary hover:opacity-90"
      >
        <span className="inline-flex size-8 items-center justify-center rounded-lg bg-accent-muted text-accent-hover">
          <Brain className="size-5" aria-hidden />
        </span>
        <span>TAS</span>
      </Link>
      <div className="flex-1" />
      {userMenu && <div className="flex shrink-0 items-center">{userMenu}</div>}
    </header>
  );
}
